import { Mixins, Component, Prop, Watch } from 'vue-property-decorator'
import MixinInterface from '@/_mixins/index'
import WatchableResourceModel from '@/views/Watcher/models/watchableResource'
import WatcherModel from '@/views/Watcher/models/watcher'

import UserAvatar from '@/_components/avatar/nuser/user.vue'

@Component({
    inheritAttrs: false,
    name: 'watchers-component',
    components: { UserAvatar },
})
export default class WatchersComponent extends Mixins<MixinInterface>() {
    @Prop({ required: true }) watchableResourceId!: string
    @Prop({ required: true }) numWatchers!: string

    menu = false
    watchableResource: WatchableResourceModel | null = null

    @Watch('menu')
    async loadWatchableResource() {
        if (this.menu) {
            this.watchableResource = await WatchableResourceModel.get(this.watchableResourceId)
        }
    }
}
